export default __webpack_public_path__ + "static/media/open-icon.f4615de4.svg";